export default __webpack_public_path__ + "static/media/atzelsfortress.1fad653e.jpg";